import { render } from "./Prenotazione.vue?vue&type=template&id=fc5639ee"
import script from "./Prenotazione.vue?vue&type=script&lang=js"
export * from "./Prenotazione.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__